import { ListsApi } from '../api-clients';
import { wrap } from '../wrap';

export const tasklistApi = {
  index: wrap(ListsApi, ListsApi.prototype.indexTaskList),
  create: wrap(ListsApi, ListsApi.prototype.createTaskList),
  update: wrap(ListsApi, ListsApi.prototype.updateTaskList),
  show: wrap(ListsApi, ListsApi.prototype.showTaskList),
  move: wrap(ListsApi, ListsApi.prototype.moveTaskList),
};
